export { default } from './CircumventionWarningMessage';
export * from './CircumventionWarningMessage';



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/messages/components/CircumventionWarningMessage/index.ts